import { Navigate, Outlet } from 'react-router-dom';

import './admin.scss';

import { useIsAdmin } from '~modules/auth/model';
import { routerKeys } from '~shared/router';

export function AdminLayout() {
	const isAdmin = useIsAdmin();

	if (!isAdmin) return <Navigate to={routerKeys.cabinet.root()} />;

	return (
		<div className="admin">
			<div className="row-group-with-rightbar">
				<Outlet />
			</div>
		</div>
	);
}
